module.exports = function() {
  return new Worker(__webpack_public_path__ + "43361b87d983bf90ac0f.worker.js");
};